import { render } from "./ListLayout.vue?vue&type=template&id=150686c6"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import NeueLoading from "@/components/neue/NeueLoading.vue";
import SimpleEmptyState from "@/components/SimpleEmptyState.vue";
script.components = Object.assign({}, { NeueLoading, SimpleEmptyState }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueLoading, SimpleEmptyState }, script.__o.components);}